import { render, staticRenderFns } from "./HelpCall.vue?vue&type=template&id=06913c2a&scoped=true&"
import script from "./HelpCall.vue?vue&type=script&lang=js&"
export * from "./HelpCall.vue?vue&type=script&lang=js&"
import style0 from "./HelpCall.vue?vue&type=style&index=0&id=06913c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06913c2a",
  null
  
)

export default component.exports